export function convertIdToDecimal(id: string, limit: number){
    const letter = id.split("")
    const result = letter.map((num) => num.charCodeAt(0))
    const joined = result.join("").slice(0, limit);
    
    return joined
}